import React, { Component, useEffect, useState } from "react";
import * as Constants from "../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import SimpleReactValidator from "simple-react-validator";
import Switch from "react-switch";
import SearchInput from "react-search-input";
import ReactDragListView from "react-drag-listview";
import LoadingButton from "../common/LoadingButton";

class CreateProgramArea extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      name: this.props.resp ? this.props.resp.data.output.name : "",
      branches: [],
      regions: [],
      citys: [],
      search: '',
      sortBy: "name",
      limit: "100000",
      page: 1,
      branch: this.props.resp ? this.props.resp.data.output.branch.id : "",
      region: this.props.resp ? this.props.resp.data.output.branch.region.id : "",
      selectedCitys: this.props.resp ? this.props.resp.data.output.branch.region.citiesList : [],
      submitting: false,

      // selectedRegion: this.props.resp ? this.props.resp.data.output.region.id : "",

    };

  }
  componentDidMount() {

    const RegionRequest = async () => {
      try {
        const token = localStorage.getItem("token");
        const currentURL = window.location.pathname;
        const parts = currentURL.split("/");
        let programid = parts.pop();
        programid = parseInt(programid);
        const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
        let compid = pathSegments[pathSegments.length - 2];
        let url = "";
        this.state.search !== ""
          ? (url =
            "program/child/region/region?" +
            "name=" +
            this.state.search +
            "&sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page)
          : (url =
            "program/child/region/region?sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page);
        const resp = await axios
          .get(Constants.api + url, {
            headers: { Authorization: `Bearer ${token}`, company: compid, program: programid, platform: Constants.pt, appVersion: Constants.av },
          })
          .then((resp) => {
            //  casetype array

            if (resp.status == 201 && resp.data.result !== "error") {
              console.log(resp.data.output.results);
              this.setState({
                regions: resp.data.output.results,
                totalResults: resp.data.output.totalResults,
              });
              console.log(this.state.Categorys);
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
            //movie array
          }).catch((err) => {
            // window.location = "/login"
          });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    };
    RegionRequest();
  }
  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      this.componentDidMount()
    );
  };

  nameHandleChange = (event) => {
    this.setState({ name: event.target.value });
  };

  branchHandleChange = (event) => {
    this.setState({ branch: event.target.value });
    this.getCitiesbyBranches(event.target.value);

  };
  regionHandleChange = (event) => {
    this.setState({ region: event.target.value });
    this.getBranchesbyRegion(event.target.value);
    // this.setState({ branches: event.target.value.branches })
  };
  getBranchesbyRegion = (id) => {
    try {
      const token = localStorage.getItem("token");
      const deletedata = new FormData();
      deletedata.append("id", id); //append the values with key, value pair

      axios
        .get(
          Constants.api + "program/child/region/region/" + id,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
          deletedata
        )
        .then((resp) => {
          //  casetype array

          if (resp.status == 200) {
            this.setState({ create: 1, branches: resp.data.output.branches });
          } else if (resp.status == 403) {
            localStorage.clear();
            window.location.href = "/";
          } else {
          }
          //movie array
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
  };
  getCitiesbyBranches = (id) => {
    try {
      const token = localStorage.getItem("token");
      const deletedata = new FormData();
      deletedata.append("id", id); //append the values with key, value pair

      axios
        .get(
          Constants.api + "program/child/region/branch/" + id,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
          deletedata
        )
        .then((resp) => {
          //  casetype array

          if (resp.status == 200) {
            console.log(resp.data.output);
            this.setState({ create: 1, citys: resp.data.output.cities.split(',') });
          } else if (resp.status == 403) {
            localStorage.clear();
            window.location.href = "/";
          } else {
          }
          //movie array
        }).catch((err) => {
          // window.location = "/login"
        });
    } catch (err) {
      // Handle Error Here
      console.error(err);
    }
  };
  handleFormSubmit = (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ submitting: true });
      const token = localStorage.getItem("token");
      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parts.pop();
      programid = parseInt(programid);
      const pathSegments = window.location.pathname.split('/'); // Split the URL path by '/'
      let compid = pathSegments[pathSegments.length - 2];
      if (this.props.resp) {
        axios
          .patch(
            Constants.api + "program/child/region/area/" + this.props.resp.data.output.id,
            {
              name: this.state.name,
              branch: { id: this.state.branch },
              region: { id: this.state.region },
              citiesList: this.state.selectedCitys


            },
            {
              headers: {
                Authorization: `Bearer ${token}`, company: compid, program: programid, appVersion: Constants.av,
                platform: Constants.pt
              },
            }
          )
          .then((res) => {
            if (res.status == 200) {
              swal("Area Updated");
              this.setState({ create: 0 });
            } else if (res.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
              // this.setState({alert:res.data.msg});
              swal("Something went wrong!");
            }
          })
          .catch((err) => {
            //localStorage.clear();
            //    window.location = "/login"
          })
          .finally(() => {
            this.setState({ submitting: false });
          });;
      } else {
        axios
          .post(
            Constants.api + "program/child/region/area/",
            {
              name: this.state.name,
              branch: { id: this.state.branch },
              region: { id: this.state.region },
              citiesList: this.state.selectedCitys


            },
            {
              headers: {
                Authorization: `Bearer ${token}`, company: compid, program: programid, appVersion: Constants.av,
                platform: Constants.pt
              },
            }
          )
          .then((res) => {
            if (res.status == 201) {
              swal("Area Added");

              this.setState({ createTemplate: 0 })
            } else if (res.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
              // this.setState({alert:res.data.msg});
              swal("Something went wrong!");
            }
          })
          .catch((err) => {
            //localStorage.clear();
            //    window.location = "/login"
          })
          .finally(() => {
            this.setState({ submitting: false });
          });;
      }
    } else {
      this.setState({ submitting: false });
      this.validator.showMessages();
    }
    this.forceUpdate();
  };
  render() {
    if (this.state.create == 0) {
      window.location.reload()
    }
    const handleCityChange = (event, cityName) => {
      let selectedCitys = this.state.selectedCitys;
      const index = selectedCitys.indexOf(cityName);
      if (index == -1) {
        selectedCitys.push(cityName)

      } else {
        let selectedCitys = selectedCitys.filter((item) => item !== cityName);

      }
      this.setState({
        selectedCitys: selectedCitys
      })
    };
    let selectedCitys = this.state.selectedCitys;
    return (
      <>
        <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
          <nav class="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 mx-4 shadow-none border-radius-xl z-index-sticky" id="navbarBlur" data-scroll="true">
            <div class="container-fluid py-1 px-3">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">

                  <li class="breadcrumb-item text-sm"><a class="opacity-5 text-dark" href="javascript:;"> Program Region</a></li>
                  <li class="breadcrumb-item text-sm text-dark active" aria-current="page">Add New</li>
                </ol>
              </nav>
              <div class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                <a href="javascript:;" class="nav-link text-body p-0">
                  <div class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                  </div>
                </a>
              </div>

            </div>
          </nav>
          <div class="card mt-4" id="basic-info">
            <div class="card-header">
              <div class="col-md-8">

              </div>
              <h5>Program Area</h5>
            </div>
            <form onSubmit={this.handleFormSubmit}>
              <div class="card-body pt-0">

                <div class="row">
                  <div class="col-md-12">
                    <label class="form-label mt-4">Name</label>
                    <input class="form-control" id="choices-skills" type="text" placeholder="" name="name" value={this.state.name} onChange={this.nameHandleChange} />
                    {this.validator.message(
                      "Area Name",
                      this.state.name,
                      "required"
                    )}
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label class="form-label mt-4">Region</label>
                    <select class="form-control" name="region" value={this.state.region} onChange={this.regionHandleChange}>
                      <option value="">Select Region</option>

                      {this.state.regions.map(function (item, i) {
                        return (<>
                          <option value={item.id}>{item.name}</option>
                        </>)
                      })}


                    </select>
                    {this.validator.message(
                      "region",
                      this.state.region,
                      "required"
                    )}
                  </div>


                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label class="form-label mt-4">Branch</label>
                    <select class="form-control" name="branch" value={this.state.branch} onChange={this.branchHandleChange}>
                      <option value="">Select Branch</option>

                      {this.state.branches.map(function (item, i) {
                        return (<>
                          <option value={item.id}>{item.name}</option>
                        </>)
                      })}


                    </select>
                    {this.validator.message(
                      "Branch",
                      this.state.branch,
                      "required"
                    )}
                  </div>


                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-label mt-4">Cities</label>
                    <div class="mx-4">
                      {this.state.citys.map(function (item, i) {
                        return (<div class="col-sm-3"> <label >
                          <input
                            type="checkbox"
                            checked={selectedCitys.includes(item)}
                            onChange={(event) => handleCityChange(event, item)}
                          />&nbsp;
                          {item}
                        </label></div>)

                      })}

                    </div>
                  </div>
                </div>
              </div>
              <div class=" mt-4" id="delete">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-sm-0 mb-4">
                    <div class="w-50">
                      {/* <p>Save State</p> */}
                      {/* <p class="text-sm mb-0">Once you delete your account, there is no going back. Please be certain.</p> */}
                    </div>
                    <div class="w-50 text-end">
                      <LoadingButton class="btn bg-gradient-success mb-0 ms-2" type="submit" name="button" loading={this.state.submitting}>Save </LoadingButton>
                    </div>
                  </div>
                </div>
              </div>

            </form>
          </div>

        </main >

      </>
    );
  }

}

export default CreateProgramArea;
